import { getCartPricing, verifyCartForCheckout } from '../../../helpers/CartPricing';
import { getDeliveryCostQuote } from '../../../helpers/DeliveryCost';
import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import SiteBreadcrumb from '../../components/layout/SiteBreadcrumb';
import BestFacilities from '../../components/shared/BestFacilities';
import { useSelector, useDispatch } from 'react-redux';
import { LOADER_DURATION } from '../../../helpers/Constants';
import { showErrorMsg, showInfoMsg, showSuccessMsg, validateAnyFormField } from '../../../helpers/ValidationHelper';
import { MakeApiCallSynchronous, MakeApiCallAsync, GetLoadSTRPPublishable } from '../../../helpers/ApiHelpers';
import Config from '../../../helpers/Config';
import rootAction from '../../../stateManagment/actions/rootAction';
import OrderSummary from '../../components/cart/OrderSummary';
import { makePriceRoundToTwoPlaces, makeProductShortDescription } from '../../../helpers/ConversionHelper';
import { Helmet } from 'react-helmet';

//--strip
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import CheckoutStripForm from '../../components/cart/CheckoutStripForm';
import { GetDefaultCurrencyCode, GetDefaultCurrencySymbol, getLanguageCodeFromSession, GetLocalizationControlsJsonDataForScreen, replaceLoclizationLabel } from '../../../helpers/CommonHelper';

//--Paypal
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import GlobalEnums from '../../../helpers/GlobalEnums';
import './Checkout.css';
import './CartVariant.css';
import CheckoutBillingInfo from '../../components/cart/CheckoutBillingInfo';
import { getShippingAddress, getOrderNoteWithBillingAddress } from '../../../helpers/CheckoutBillingAddress';


// Make sure to call `loadStripe` outside of a component's render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(process.env.REACT_APP_STRP_PUBLISHABLE_KEY);



const Checkout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();



    const [showCardSectionStripe, setshowCardSectionStripe] = useState(false);
    const [showCardSectionPaypal, setshowCardSectionPaypal] = useState(false);
    const [PaymentMethod, setPaymentMethod] = useState(process.env.REACT_APP_STRIPE_PAYMENT_METHOD ?? 5);
    const [siteTitle, setSiteTitle] = useState(Config['SITE_TTILE']);
    const [OrderNote, setOrderNote] = useState('');
    const [billingSameAsShipping, setBillingSameAsShipping] = useState(true);
    const [customBillingAddress, setCustomBillingAddress] = useState('');
    const [CartSubTotal, setCartSubTotal] = useState(0);
    const [ShippingSubTotal, setShippingSubTotal] = useState(0);
    const [deliveryQuoteError, setDeliveryQuoteError] = useState('');
    const [deliveryQuoteLoading, setDeliveryQuoteLoading] = useState(true);
    const [OrderTotal, setOrderTotal] = useState(0);
    const [couponDiscount, setCouponDiscount] = useState(0);
    const [cartProductsData, setCartProductsData] = useState([]);
    const [CouponCode, setCouponCode] = useState('');
    const [IsCouponCodeApplied, setIsCouponCodeApplied] = useState(false);
    const [IsAlreadyDiscountApplied, setIsAlreadyDiscountApplied] = useState(false);
    const [CouponCodeCssClass, setCouponCodeCssClass] = useState('cart-coupon-code');
    const [paypalOrderID, setPaypalOrderID] = useState(false);
    const [LocalizationLabelsArray, setLocalizationLabelsArray] = useState([]);
    

    const loginUserDataJson = useSelector(state => state.userReducer.user);
    const loginUser = JSON.parse(loginUserDataJson ?? "{}");
    const billingAddress = billingSameAsShipping ? getShippingAddress(loginUser) : customBillingAddress;
    const validateBillingAddress = () => {
        if (!billingAddress.trim()) throw new Error('Please enter your billing address.');
        if (billingAddress.trim().length > 1000) throw new Error('Please keep the billing address within 1,000 characters.');
    };

    const cartJsonDataSession = useSelector(state => state.cartReducer.cartItems);
    const cartItemsSession = JSON.parse(cartJsonDataSession ?? "[]");
    const OrderTotalAfterDiscount = IsCouponCodeApplied ? Math.max(0, OrderTotal - couponDiscount) : 0;
    const refreshDeliveryQuote = async () => {
        try {
            const quote = await getDeliveryCostQuote(cartItemsSession, loginUser);
            setShippingSubTotal(quote.totalDeliveryCost);
            setDeliveryQuoteError('');
            return quote;
        } catch (error) {
            setDeliveryQuoteError(error.message);
            throw error;
        }
    };


    if (loginUser == undefined || loginUser.UserID == undefined || loginUser.UserID < 1) {
        navigate('/' + getLanguageCodeFromSession() + '/login');
    }

    if (cartItemsSession == undefined || cartItemsSession == null || cartItemsSession.length < 1) {
        showInfoMsg('Your cart is empty');
        navigate('/' + getLanguageCodeFromSession() + '/');
    }

    const GetCouponCodeInfo = async () => {

        if (IsCouponCodeApplied) {
            showInfoMsg('Coupon code is already applied!');
            return false;
        }


        let isValid = validateAnyFormField('Coupon Code', CouponCode, 'text', null, 30, true);
        if (isValid == false) {
            return false;
        }



        const headersCoupon = {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        }

        const paramCoupon = {
            requestParameters: {
                CouponCode: CouponCode,
                cartJsonData: JSON.stringify(cartItemsSession),
            },
        };


        const couponResponse = await MakeApiCallAsync(Config.END_POINT_NAMES['GET_COUPON_CODE_DISCOUNT'], Config['COMMON_CONTROLLER_SUB_URL'], paramCoupon, headersCoupon, "POST", true);


        if (couponResponse != null && couponResponse.data != null) {

            let copounData = JSON.parse(couponResponse.data.data);
            console.log(copounData);
            if (copounData != undefined && copounData.DiscountValueAfterCouponAppliedWithQuantity != undefined && copounData.DiscountValueAfterCouponAppliedWithQuantity > 0) {
                setCouponDiscount(Number(copounData.DiscountValueAfterCouponAppliedWithQuantity) || 0);
                setIsCouponCodeApplied(true);
            } else {
                showErrorMsg('Invalid coupon code!');
            }

        }



    }

    const handleCheckoutOnSubmit = async (e) => {
        

        try {
            e.preventDefault();

            validateBillingAddress();
            const [cartQuote, deliveryQuote] = await Promise.all([
                verifyCartForCheckout(cartItemsSession), refreshDeliveryQuote()
            ]);
            setCartSubTotal(cartQuote.cartSubTotal);
            setOrderTotal(cartQuote.cartSubTotal + deliveryQuote.totalDeliveryCost);

            //-- First Disable all forms
            setshowCardSectionStripe(false);
            setshowCardSectionPaypal(false);

            if (PaymentMethod === process.env.REACT_APP_STRIPE_PAYMENT_METHOD) {
                setshowCardSectionStripe(true);
            } else if (PaymentMethod === process.env.REACT_APP_PAYPAL_PAYMENT_METHOD) {
                setshowCardSectionPaypal(true);
            }
            else if (PaymentMethod === process.env.REACT_APP_CASH_ON_DELIVERY_PAYMENT_METHOD) {
                let isYes = window.confirm("Do you really want place order?");
                if (isYes) {

                    //--start loader
                    dispatch(rootAction.commonAction.setLoading(true));


                    PlaceAndConfirmCustomerOrder(null);

                    //--stop loader
                    setTimeout(() => {
                        dispatch(rootAction.commonAction.setLoading(false));
                    }, LOADER_DURATION);

                }
            }
        } catch (err) {
            showErrorMsg(err.message || "An error occured. Please try again!");
            console.log(err.message);
            if (PaymentMethod === process.env.REACT_APP_STRIPE_PAYMENT_METHOD) {
                HandleStripCardModal();
                HandlePaypalCardModal();
            }

            //--stop loader
            setTimeout(() => {
                dispatch(rootAction.commonAction.setLoading(false));
            }, LOADER_DURATION);
        }



    }


    const PlaceAndConfirmCustomerOrder = async (StripPaymentToken, payPalOrderConfirmJson = "{}") => {
        
        try {
            validateBillingAddress();

            const [cartQuote, deliveryQuote] = await Promise.all([
                verifyCartForCheckout(cartItemsSession), refreshDeliveryQuote()
            ]);
            setCartSubTotal(cartQuote.cartSubTotal);
            setOrderTotal(cartQuote.cartSubTotal + deliveryQuote.totalDeliveryCost);

            const headersStrip = {
                Accept: 'application/json',
                'Content-Type': 'application/json',

            }


            const paramSrip = {
                requestParameters: {
                    UserID: loginUser.UserID,
                    OrderNote: getOrderNoteWithBillingAddress(billingAddress, OrderNote),
                    cartJsonData: JSON.stringify(cartItemsSession),
                    CouponCode: IsCouponCodeApplied == true ? CouponCode : "",
                    PaymentMethod: PaymentMethod,
                    paymentToken: StripPaymentToken ?? "",
                    payPalOrderConfirmJson: payPalOrderConfirmJson ?? "",
                    recordValueJson: "[]",
                },
            };


            
            const stripServerResponse = await MakeApiCallAsync(Config.END_POINT_NAMES['POST_CUSTOMER_ORDER'], Config['COMMON_CONTROLLER_SUB_URL'], paramSrip, headersStrip, "POST", true);
            if (stripServerResponse != null && stripServerResponse.data != null && stripServerResponse.status == 200) {
                let stripServerResponseDetail = JSON.parse(stripServerResponse.data.data != undefined && stripServerResponse.data.data != "" ? stripServerResponse.data.data : "[]");

                if (stripServerResponseDetail.length > 0 && stripServerResponseDetail[0].ResponseMsg != undefined && stripServerResponseDetail[0].ResponseMsg == "Order Placed Successfully") {
                    showSuccessMsg("Order Placed Successfully!");




                    setTimeout(function () {
                        navigate('/' + getLanguageCodeFromSession() + '/');

                        //--clear customer cart
                        dispatch(rootAction.cartAction.setCustomerCart('[]'));
                        dispatch(rootAction.cartAction.SetTotalCartItems(0));
                        localStorage.setItem("cartItems", "[]");

                    }, 1000);


                } else {
                    showErrorMsg("An error occured. Please try again!");

                }

            } else {
                showErrorMsg("An error occured. Please try again!");

            }


            if (PaymentMethod === process.env.REACT_APP_STRIPE_PAYMENT_METHOD) {
                HandleStripCardModal();
            } else if (PaymentMethod === process.env.REACT_APP_PAYPAL_PAYMENT_METHOD) {
                HandlePaypalCardModal();
            }





        } catch (err) {
            showErrorMsg(err.message || "An error occured. Please try again!");
            console.log(err.message);
            if (PaymentMethod === process.env.REACT_APP_STRIPE_PAYMENT_METHOD) {
                HandleStripCardModal();
            }

            //--stop loader
            setTimeout(() => {
                dispatch(rootAction.commonAction.setLoading(false));
            }, LOADER_DURATION);

        }


    }


    const HandleStripCardModal = () => {
        setshowCardSectionStripe(!showCardSectionStripe);
    }

    const HandlePaypalCardModal = () => {
        setshowCardSectionPaypal(!showCardSectionPaypal);
    }

    // creates a paypal order
    const createOrder = async (data, actions) => {
        const [cartQuote, deliveryQuote] = await Promise.all([
            verifyCartForCheckout(cartItemsSession), refreshDeliveryQuote()
        ]);
        const payable = Math.max(0, cartQuote.cartSubTotal + deliveryQuote.totalDeliveryCost - (IsCouponCodeApplied ? couponDiscount : 0));
        return actions.order
            .create({
                purchase_units: [
                    {
                        description: "Sunflower",
                        amount: {
                            //currency_code: "USD",
                            currency_code: GetDefaultCurrencyCode(),
                            value: payable.toFixed(2),
                        },
                    },
                ],
                // not needed if a shipping address is actually needed
                application_context: {
                    shipping_preference: "NO_SHIPPING",
                },
            })
            .then((paypalOrderID) => {
                setPaypalOrderID(paypalOrderID);
                return paypalOrderID;
            });
    };

    // check paypal Approval
    const onApprove = (data, actions) => {
        
        return actions.order.capture().then(function (details) {
            const { payer } = details;
            //setSuccess(true); replace with your own

            //-- Set paypal json response if approve
            let JsonDetail = JSON.stringify(details);

            //--start loader
            dispatch(rootAction.commonAction.setLoading(true));

            setTimeout(() => {
                PlaceAndConfirmCustomerOrder(null, JsonDetail);
            }, 500);

            //--stop loader
            setTimeout(() => {
                dispatch(rootAction.commonAction.setLoading(false));
            }, LOADER_DURATION);


            HandlePaypalCardModal();
        });
    };

    //capture likely error for paypal
    const onError = (data, actions) => {
        HandlePaypalCardModal();
        showErrorMsg("An error occured. Please try again!");
    };


    useEffect(() => {
        setPaymentMethod("6");
        // declare the data fetching function
        const dataOperationInUseEffect = async () => {

            setDeliveryQuoteLoading(true);
            setDeliveryQuoteError('');
            const [finalData, deliveryQuote] = await Promise.all([
                getCartPricing(cartItemsSession), getDeliveryCostQuote(cartItemsSession, loginUser)
            ]);
            setCartProductsData(finalData.productsData);
            setCartSubTotal(finalData.cartSubTotal);
            setShippingSubTotal(deliveryQuote.totalDeliveryCost);
            setOrderTotal(finalData.cartSubTotal + deliveryQuote.totalDeliveryCost);
            setIsAlreadyDiscountApplied(finalData.productsData.some(item => item.DiscountedPrice > 0));


        }


        //--start loader
        dispatch(rootAction.commonAction.setLoading(true));


        // call the function
        dataOperationInUseEffect().catch(error => { setDeliveryQuoteError(error.message); showErrorMsg(error.message); })
            .finally(() => setDeliveryQuoteLoading(false));

        //--stop loader
        setTimeout(() => {
            dispatch(rootAction.commonAction.setLoading(false));
        }, LOADER_DURATION);

    }, [cartJsonDataSession, loginUser.PostalCode, loginUser.StateName])


    useEffect(() => {
        // declare the data fetching function
        const dataOperationFunc = async () => {

            //-- Get website localization data
            let arryRespLocalization = await GetLocalizationControlsJsonDataForScreen(GlobalEnums.Entities["Checkout"], null);
            if (arryRespLocalization != null && arryRespLocalization != undefined && arryRespLocalization.length > 0) {
                await setLocalizationLabelsArray(arryRespLocalization);
            }
        }
        // call the function
        dataOperationFunc().catch(console.error);
    }, [])

    return (
        <>


            <Helmet>
                <title>{siteTitle} - Checkout</title>
                <meta name="description" content={siteTitle + " - Checkout"} />
                <meta name="keywords" content="Checkout"></meta>
            </Helmet>

            <SiteBreadcrumb title="Checkout" />

            <section className="checkout-area checkout-modern ptb-60">
                <div className="container">
                    {/* <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <div className="user-actions">
                                <i className="fas fa-sign-in-alt"></i>
                                <span>Returning customer? <Link to="#">Click here to login</Link></span>
                            </div>
                        </div>
                    </div> */}

                    <form className="checkout-modern__form" onSubmit={handleCheckoutOnSubmit}>
                        <div className="row">
                            <div className="col-lg-5 col-md-5">
                                <div className="billing-details checkout-modern__card">
                                    <h3 className="title" id="lbl_check_billdetail">
                                        {LocalizationLabelsArray.length > 0 ?
                                            replaceLoclizationLabel(LocalizationLabelsArray, "Billing Details", "lbl_check_billdetail")
                                            :
                                            "Billing Details"
                                        }
                                    </h3>

                                    <CheckoutBillingInfo user={loginUser} labels={LocalizationLabelsArray}
                                        billingAddress={billingAddress} sameAsShipping={billingSameAsShipping}
                                        onSameAsShippingChange={setBillingSameAsShipping}
                                        onBillingAddressChange={setCustomBillingAddress} />

                                    <div className="row">
                                        <div className="col-lg-12 col-md-12">
                                            <div className="form-group">
                                                <label htmlFor="OrderNote">Order notes (optional)</label>
                                                <textarea name="OrderNote" id="OrderNote" cols="30" rows="3" placeholder="Order Notes" className="form-control"
                                                    value={OrderNote}
                                                    onChange={(e) => setOrderNote(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-7 col-md-7">
                                <div className="order-details checkout-modern__card checkout-modern__order-card">
                                    <h3 className="title" id="lbl_check_yrorder">
                                        {LocalizationLabelsArray.length > 0 ?
                                            replaceLoclizationLabel(LocalizationLabelsArray, "Your Order", "lbl_check_yrorder")
                                            :
                                            "Your Order"
                                        }
                                    </h3>


                                    <>
                                        {
                                            cartProductsData != undefined && cartProductsData != null && cartProductsData.length > 0
                                                ?
                                                <>
                                                    <div className="order-table table-responsive">
                                                        <table className="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col" id="lbl_hdr_check_prdname">
                                                                        {LocalizationLabelsArray.length > 0 ?
                                                                            replaceLoclizationLabel(LocalizationLabelsArray, "Product Name", "lbl_hdr_check_prdname")
                                                                            :
                                                                            "Product Name"
                                                                        }  
                                                                    </th>
                                                                    <th scope="col" id="lbl_hdr_check_price">
                                                                        {LocalizationLabelsArray.length > 0 ?
                                                                            replaceLoclizationLabel(LocalizationLabelsArray, "Price", "lbl_hdr_check_price")
                                                                            :
                                                                            "Price"
                                                                        }  
                                                                    </th>
                                                                    <th scope="col" id="lbl_hdr_check_qty">
                                                                        {LocalizationLabelsArray.length > 0 ?
                                                                            replaceLoclizationLabel(LocalizationLabelsArray, "Quantity", "lbl_hdr_check_qty")
                                                                            :
                                                                            "Quantity"
                                                                        }  
                                                                    </th>
                                                                    <th scope="col" id="lbl_hdr_check_total">
                                                                        {LocalizationLabelsArray.length > 0 ?
                                                                            replaceLoclizationLabel(LocalizationLabelsArray, "Total", "lbl_hdr_check_total")
                                                                            :
                                                                            "Total"
                                                                        }  
                                                                    </th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                {cartProductsData?.map((data, idx) => (

                                                                    <tr key={idx}>
                                                                        <td className="product-name">
                                                                            <Link to="#">

                                                                                {
                                                                                    makeProductShortDescription(data.ProductName, 50)
                                                                                }
                                                                            </Link>
                                                                            {data.SelectedVariantName && <div className="cart-variant-summary">
                                                                                <strong>Variant: {data.SelectedVariantName}</strong>
                                                                                {data.SelectedVariantSku && <small>SKU: {data.SelectedVariantSku}</small>}
                                                                            </div>}
                                                                        </td>

                                                                        <td className="product-name">
                                                                            <span className="unit-amount">
                                                                                {data.DiscountedPrice != undefined && data.DiscountedPrice > 0 ?
                                                                                    <>
                                                                                        <del style={{ color: "#9494b9" }}>{GetDefaultCurrencySymbol()}{makePriceRoundToTwoPlaces(data.Price)}</del> &nbsp; {GetDefaultCurrencySymbol()}{makePriceRoundToTwoPlaces(data.DiscountedPrice)}
                                                                                    </>
                                                                                    :
                                                                                    <>
                                                                                        {GetDefaultCurrencySymbol()}{makePriceRoundToTwoPlaces(data.Price)}
                                                                                    </>
                                                                                }
                                                                            </span>
                                                                        </td>

                                                                        <td className="product-name">
                                                                            {data.Quantity}
                                                                        </td>

                                                                        {(() => {

                                                                            let itemSubTotal = (data.DiscountedPrice != undefined && data.DiscountedPrice > 0 ? data.DiscountedPrice : data.Price) * (data.Quantity ?? 1);

                                                                            return (

                                                                                <td className="product-total">
                                                                                    <span className="subtotal-amount">{GetDefaultCurrencySymbol()}{makePriceRoundToTwoPlaces(itemSubTotal)}</span>
                                                                                </td>
                                                                            );

                                                                        })()}


                                                                    </tr>
                                                                ))}

                                                                <tr>
                                                                    <td className="order-subtotal" colSpan={3}>
                                                                        <span id="lbl_check_cartsubtotal">
                                                                            {LocalizationLabelsArray.length > 0 ?
                                                                                replaceLoclizationLabel(LocalizationLabelsArray, "Cart Subtotal", "lbl_check_cartsubtotal")
                                                                                :
                                                                                "Cart Subtotal"
                                                                            }  
                                                                        </span>
                                                                    </td>


                                                                    <td className="order-subtotal-price">
                                                                        <span className="order-subtotal-amount">{GetDefaultCurrencySymbol()}{makePriceRoundToTwoPlaces(CartSubTotal)}</span>
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td className="order-shipping" colSpan={3}>
                                                                        <span id="lbl_check_shipping">
                                                                            Delivery charge
                                                                        </span>
                                                                    </td>


                                                                    <td className="shipping-price">
                                                                        <span>{deliveryQuoteLoading ? 'Calculating…' : deliveryQuoteError ? 'Unavailable' : `${GetDefaultCurrencySymbol()}${makePriceRoundToTwoPlaces(ShippingSubTotal)}`}</span>
                                                                    </td>
                                                                </tr>

                                                                {deliveryQuoteError && <tr><td colSpan={4}><p role="alert">{deliveryQuoteError}</p></td></tr>}

                                                                <tr>
                                                                    <td className="total-price" colSpan={3}>
                                                                        <span id="lbl_check_ordtotal">
                                                                            {LocalizationLabelsArray.length > 0 ?
                                                                                replaceLoclizationLabel(LocalizationLabelsArray, "Order Total", "lbl_check_ordtotal")
                                                                                :
                                                                                "Order Total"
                                                                            } 
                                                                        </span>
                                                                    </td>



                                                                    <td className="product-subtotal">
                                                                        <span className="subtotal-amount">
                                                                            {deliveryQuoteLoading ? 'Calculating…' : deliveryQuoteError ? 'Unavailable' : IsCouponCodeApplied
                                                                                ?
                                                                                <>
                                                                                    <del>{GetDefaultCurrencySymbol()} {makePriceRoundToTwoPlaces(OrderTotal)}</del>&nbsp; &nbsp; {GetDefaultCurrencySymbol()}{makePriceRoundToTwoPlaces(OrderTotalAfterDiscount)}
                                                                                </>



                                                                                :
                                                                                `${GetDefaultCurrencySymbol()} ${makePriceRoundToTwoPlaces(OrderTotal)}`
                                                                            }

                                                                        </span>
                                                                    </td>
                                                                </tr>


                                                                {/* <tr style={{ display: IsAlreadyDiscountApplied ? "none" : '' }}>
                                                                    <td className="total-price" colSpan={3}>
                                                                        <div className='login-form'>
                                                                            <div className='form-group' style={{ marginBottom: '0' }}>
                                                                                <input
                                                                                    type="text"
                                                                                    name="phone"
                                                                                    className={`form-control ${IsCouponCodeApplied ? CouponCodeCssClass : ''}`}
                                                                                    placeholder='Enter Coupon Code'
                                                                                    value={CouponCode}
                                                                                    onChange={(e) => setCouponCode(e.target.value)}
                                                                                    maxLength={30}
                                                                                />

                                                                            </div>

                                                                        </div>

                                                                    </td>



                                                                    <td className="product-subtotal">
                                                                        <button className='btn btn-primary'
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                GetCouponCodeInfo();
                                                                            }}
                                                                            id="lbl_check_applycpn"
                                                                        >
                                                                            {LocalizationLabelsArray.length > 0 ?
                                                                                replaceLoclizationLabel(LocalizationLabelsArray, "Apply Coupon", "lbl_check_applycpn")
                                                                                :
                                                                                "Apply Coupon"
                                                                            }
                                                                        </button>
                                                                    </td>
                                                                </tr> */}

                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </>
                                                :
                                                <>
                                                </>
                                        }

                                    </>

                                    <div className="payment-method">
                                        {/* <p>
                                            <input type="radio" id="direct-bank-transfer" name="radio-group" defaultChecked={true} />
                                            <label htmlFor="direct-bank-transfer">Direct Bank Transfer</label>

                                            Make your payment directly into our bank account. Please use your Order ID as the payment reference. Your order will not be shipped until the funds have cleared in our account.
                                        </p>
                                        <p>
                                            <input type="radio" id="paypal" name="radio-group" />
                                            <label htmlFor="paypal">PayPal</label>
                                        </p>
                                        <p>
                                            <input type="radio" id="cash-on-delivery" name="radio-group" />
                                            <label htmlFor="cash-on-delivery">Cash on Delivery</label>
                                        </p> */}


                                        <div className='row login-form'>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <label>
                                                        {LocalizationLabelsArray.length > 0 ?
                                                            replaceLoclizationLabel(LocalizationLabelsArray, "Payment Method", "lbl_check_paymethod")
                                                            :
                                                            "Payment Method"
                                                        }  
                                                    </label>

                                                    <select
    className="form-control"
    name="PaymentMethod"
    value={PaymentMethod}
    onChange={(e) => setPaymentMethod(e.target.value)}
>
    <option value="10">Please select</option>
    <option value="6">Pay Post Enquiry</option>
</select>



                                                </div>
                                            </div>

                                        </div>

                                    </div>

                                    {/* <Payment
                                        amount={totalAmount * 100}
                                        disabled={disable}
                                    /> */}

                                    <div className="checkout-modern__assurance">
                                        <span><i className="fas fa-shield-alt" aria-hidden="true" /> Secure checkout</span>
                                        <span><i className="fas fa-headset" aria-hidden="true" /> Customer support</span>
                                    </div>

                                    <>
                                        <button type='submit' disabled={deliveryQuoteLoading || Boolean(deliveryQuoteError)} className='btn btn-primary checkout-modern__submit' id="lbl_check_placeorder">
                                            {LocalizationLabelsArray.length > 0 ?
                                                replaceLoclizationLabel(LocalizationLabelsArray, "Place Order", "lbl_check_placeorder")
                                                :
                                                "Place Enquiry"
                                            } 
                                        </button>

                                    </>


                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </section>


            <BestFacilities />

            {/*Stripe card section starts here */}
            {
                showCardSectionStripe == true
                    ?


                    <div className="modal fade productQuickView show" style={{ paddingRight: '16px', display: 'block' }}>

                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        HandleStripCardModal(e);
                                    }}
                                >
                                    <span aria-hidden="true"><i className="fas fa-times"></i></span>
                                </button>
                                <div className="row align-items-center">


                                    <div className="col-lg-12 col-md-12">
                                        <div className="product-content">
                                            <Elements stripe={stripePromise}>
                                                <CheckoutStripForm

                                                    UserID={loginUser.UserID}
                                                    OrderNote={OrderNote}
                                                    cartJsonData={JSON.stringify(cartItemsSession)}
                                                    ShippingSubTotal={ShippingSubTotal}
                                                    OrderTotal={OrderTotal}
                                                    OrderTotalAfterDiscount={OrderTotalAfterDiscount}
                                                    CouponCode={CouponCode}
                                                    HandleStripCardModal={HandleStripCardModal}
                                                    PlaceAndConfirmCustomerOrder={PlaceAndConfirmCustomerOrder}

                                                />
                                            </Elements>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    :
                    <>
                    </>
            }

            {/* Stripe card section ends here */}

            {/* Paypal card section starts here */}

            {
                showCardSectionPaypal == true
                    ?

                    <PayPalScriptProvider
                        options={{
                            "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
                        }}
                    >
                        <div className="modal fade productQuickView show" style={{ paddingRight: '16px', display: 'block' }}>

                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            HandlePaypalCardModal(e);
                                        }}
                                    >
                                        <span aria-hidden="true"><i className="fas fa-times"></i></span>
                                    </button>
                                    <div className="row align-items-center">


                                        <div className="col-lg-12 col-md-12">
                                            <div className="product-content">
                                                <PayPalButtons
                                                    style={{ layout: "vertical" }}
                                                    createOrder={createOrder}
                                                    onApprove={onApprove}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </PayPalScriptProvider>

                    :
                    <>
                    </>


            }


            {/* Paypal card section ends here */}


        </>
    );
}

export default Checkout;
